<template>
<div class="ui container">
  <div class="ui column grid centered">
    <div class="four wide column">
      <div class="wrapper-authenticate">
        <h1>Login</h1>
        <t-form-login />
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  components: {
    TFormLogin: () => import('@/components/forms/login')
  }
}
</script>

<style lang="scss" scoped>
.wrapper-authenticate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 70px);
}
</style>
